import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Http, RequestOptions, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { AuthService, User } from '../user/auth.service';
import { SettingsStateStore } from '../settings/settings.state.store';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Website } from '../website-builder/wedding';

@Component({
  selector: 'app-translation-settings',
  templateUrl: './translation-settings.component.html',
  styleUrls: ['./translation-settings.component.scss']
})
export class TranslationSettingsComponent implements OnInit {
  loaded: boolean;
  enableTranslations = false;
  secondLanguage = '';
  defaultLanguage = 'english';
  user: User;
  translationInProgress: boolean = false;
  website: Website;
  disableSave = false;


  constructor(
    private _http: Http,
    private _router: Router,
    private _authService: AuthService,
    private _settingsState: SettingsStateStore,
    private _websiteState: WebsiteStateStore

  ) { }
  openModal() {
    document.getElementById('modal').style.display = 'block';
    document.body.style.overflow = 'hidden'; // Prevent body scrolling
  }
  
   closeModal() {
    document.getElementById('modal').style.display = 'none';
    document.body.style.overflow = 'auto'; // Restore body scrolling
  }
  ngOnInit() {
    this.loaded = true;
    this._authService.user.subscribe(user => {

      this.user = user;
    });

    this._settingsState.getState().subscribe(state => {
      if (state && state.settings){
      this.enableTranslations = state.settings.enableTranslations;
      this.secondLanguage = state.settings.secondLanguage;
      this.defaultLanguage = state.settings.defaultLanguage || "English";
      this.translationInProgress = state.settings.translationsInProgress;
      }
    });

    this._websiteState.getState().subscribe(state => {
      if (state && state.website){
        this.website = state.website;
    }
    });
  }

  onToggleChange() {
    if (!this.enableTranslations) {
      this.secondLanguage = '';
      this.defaultLanguage = 'English';
    }
  }
  changeSecondLang(){
    this.defaultLanguage = 'English';
    this.disableSave = false
  }


  


  save() {
    // Your save logic here

    if(this.website.defaultMode){
      this._websiteState.updateWebsite(this.website);
    }
    
    this.translationInProgress = true;
    if (this.user != null) {
      this._authService.authToken().subscribe(token => {

        let formValue = {
          token: token,
          enableTranslations: this.enableTranslations,
          secondLanguage: this.secondLanguage,
          defaultLanguage: this.defaultLanguage
        }
        const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
        const options = new RequestOptions({ headers: headers });

        return this._http
          .post(environment.firebase.clouldFunctionHost + '/translatzzzze', formValue, options)
          .toPromise()
          .then((response: any) => {
            this.disableSave = true;
            // this.settingsProcessing = false;
            // this._router.navigate(['registry', 'add-payment-methods'])
          })
          .catch((e: any) => {
            // this.settingsProcessing = false;
            this.disableSave = false;


          })
      })


    }

  }
}



// WEBPACK FOOTER //
// ./src/app/translation-settings/translation-settings.component.ts